import { render } from "./Tournaments.vue?vue&type=template&id=8b7d0580&ts=true"
import script from "./Tournaments.vue?vue&type=script&lang=ts"
export * from "./Tournaments.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__